import {AiCriteria} from './AiCriteria';
import {AiResponse} from '../message/AiResponse';
import {AiScenario} from './AiScenario';
import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';

export class AiWrapper extends BaseWrapper<AiResponse, AiCriteria, AiScenario>  {}

